'use strict';

var PricingSummaryFareChangeByODFilterFactory = function PricingSummaryFareChangeByODFilterFactory(DataFilter) {
  function PricingSummaryFareChangeByOD() {
    DataFilter.call(this, 'pricing-summary-fare-change', 'summary-od', 1);
  }
  PricingSummaryFareChangeByOD.prototype = Object.create(DataFilter.prototype);
  PricingSummaryFareChangeByOD.prototype.filter = function (data, range) {
    return DataFilter.prototype.filter(data, range, 'market');
  };
  return PricingSummaryFareChangeByOD;
};
PricingSummaryFareChangeByODFilterFactory.$inject = ['DataFilterFactory'];
module.exports = PricingSummaryFareChangeByODFilterFactory;